import {
  FETCH_PRODUCTS,
  SET_PRODUCTS,
  SAVE_PRODUCT_REQUEST,
  SAVE_PRODUCT_SUCCESS,
  SAVE_PRODUCT_FAILURE,
  PRODUCT_SET_FILTER,
  PRODUCT_MODAL_OPEN,
  PRODUCT_MODAL_CLOSE,
  ProductCategory,
} from './actions';

export interface ProductState {
  list: ProductCategory[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
  modalOpen: boolean;
  editing: ProductCategory | null;
}

const initialState: ProductState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,

  filterName: '',
  modalOpen: false,
  editing: null,
};

export default function productManagerReducer(
  state: ProductState = initialState,
  action: any
): ProductState {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return { ...state, loading: true, error: undefined };

    case SET_PRODUCTS:
      return { ...state, loading: false, list: action.payload ?? [] };

    case SAVE_PRODUCT_REQUEST:
      return { ...state, saving: true, error: undefined };

    case SAVE_PRODUCT_SUCCESS:
      return { ...state, saving: false };

    case SAVE_PRODUCT_FAILURE:
      return { ...state, saving: false, error: action.error };

    case PRODUCT_SET_FILTER:
      return { ...state, filterName: action.payload ?? '' };

    case PRODUCT_MODAL_OPEN:
      return { ...state, modalOpen: true, editing: action.payload ?? null };

    case PRODUCT_MODAL_CLOSE:
      return { ...state, modalOpen: false, editing: null };

    default:
      return state;
  }
}